'use strict';

exports.__esModule = !0, exports.createReactorElement = createReactorElement;

var _react = require('react');

function createReactorElement(Reactor, component, loaderComponent, errorComponent) {
  return function () {
    var passthroughProps = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
    return (0, _react.createElement)(Reactor, {
      wait: component,
      error: errorComponent,
      loader: loaderComponent,
      passthroughProps: passthroughProps
    });
  };
}